import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ActionTableCell, ExTable, TableBody, TableCell, TableHead, TableRow, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useDownloadCsvCouponsApi, useFetchCouponsApi } from 'api/coupon'
import { Coupon, CouponSearchForm } from 'entities/coupon'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { couponColumnInfoList, CouponTableData } from './coupon_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { InputField } from 'components/shared/input'
import { useState } from 'react'
import { EditCouponForm, NewCouponForm } from './coupon_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const CouponsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<CouponSearchForm>()
    const preSearchForm = useForm<CouponSearchForm>(params)
    const searchForm = useForm<CouponSearchForm>(params)
    const api = useFetchCouponsApi(searchForm)
    const downloadCsvApi = useDownloadCsvCouponsApi(searchForm)
    const checkIdForm = useMultipleCheckForm<Coupon>()
    const couponDisplaySetting = useDisplaySetting(couponColumnInfoList(searchForm), 'Coupon')
    const [selectedCoupon, setSelectedCoupon] = useState<Coupon>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof CouponSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`coupons?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditCouponForm
                coupon={selectedCoupon}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="クーポン一覧"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewCouponForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <InputField
                        attr="name"
                        form={preSearchForm}
                        placeholder="名称"
                        onPressEnter={() => {
                            searchForm.updateObject('name', preSearchForm.getValue('name'))
                        }}
                        style={{ marginBottom: 0, width: 250 }}
                    />
                </Flex>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={couponDisplaySetting} />
                                <TableCell th width={140}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={couponDisplaySetting.getColumnLength() + 1}>
                            {api.response.results.map((coupon: Coupon) => {
                                return (
                                    <TableRow key={`coupon-${coupon.id}`}>
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedCoupon(coupon)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <CouponTableData coupon={coupon} displaySetting={couponDisplaySetting} />
                                        <TableCell>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                disabled={!coupon.hasCode}
                                                onClick={() => {
                                                    props.history.push(`/coupons/${coupon.id}/histories?couponName=${coupon.name}`)
                                                }}
                                            >
                                                コード発行履歴
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            {/* <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Coupon"
            ></SelectionFixedFooter> */}
        </>
    )
}

export default withRouter(CouponsPage)
